import React, { Component, useEffect, useState } from "react";
import { Route } from "react-router";
import Header from "../Header";
import Footer from "../Footer";
import banner_img from "../../../images/banner-profile.jpg";
import { API_TOKEN_NAME, IMAGE_URL, SITE_URL } from "../../../constants";
import { scAxiosAdmin } from "../../..";
import { Helmet } from "react-helmet";
import SEO from "../../Seo";
import LeftSidebar from "../../admin/LeftSidebar";
import PhotoGalleryTabInner from "./PhotoGalleryTabInner";
import case_under from "../../../images/case_under.png";
import Loading from "../../../images/Loading_icon.gif";

const tabData = [
  {
    id: "home",
    label: "EVENTS AND SERVICES",
    images: [
      "https://picsum.photos/id/26/415/622",
      "https://picsum.photos/id/13/415/276",
      "https://picsum.photos/id/20/415/276",
      "https://picsum.photos/id/57/415/622",
      "https://picsum.photos/id/60/415/622",
      "https://picsum.photos/id/128/415/276",
      "https://picsum.photos/id/160/415/622",
      "https://picsum.photos/id/171/415/276",
      "https://picsum.photos/id/178/415/276",
      "https://picsum.photos/id/181/415/622",
      "https://picsum.photos/id/225/415/622",
      "https://picsum.photos/id/229/415/276",
      "https://picsum.photos/id/230/415/622",
      "https://picsum.photos/id/250/415/276",
      "https://picsum.photos/id/233/415/276",
      "https://picsum.photos/id/265/415/622",
      "https://picsum.photos/id/311/415/622",
      "https://picsum.photos/id/316/415/276",
    ],
  },
  {
    id: "profile",
    label: "ROOM",
    images: [
      "https://picsum.photos/id/160/415/622",
      "https://picsum.photos/id/171/415/276",
      "https://picsum.photos/id/178/415/276",
      "https://picsum.photos/id/181/415/622",
      "https://picsum.photos/id/225/415/622",
      "https://picsum.photos/id/229/415/276",
    ],
  },
  {
    id: "contact",
    label: "HOSPITAL VIEW",
    images: [
      "https://picsum.photos/id/230/415/622",
      "https://picsum.photos/id/250/415/276",
      "https://picsum.photos/id/233/415/276",
      "https://picsum.photos/id/265/415/622",
      "https://picsum.photos/id/311/415/622",
      "https://picsum.photos/id/316/415/276",
    ],
  },
  {
    id: "equipments",
    label: "EQUIPMENTS",
    images: [
      "https://picsum.photos/id/230/415/622",
      "https://picsum.photos/id/250/415/276",
      "https://picsum.photos/id/233/415/276",
      "https://picsum.photos/id/265/415/622",
      "https://picsum.photos/id/311/415/622",
      "https://picsum.photos/id/316/415/276",
      "https://picsum.photos/id/230/415/622",
      "https://picsum.photos/id/250/415/276",
      "https://picsum.photos/id/233/415/276",
      "https://picsum.photos/id/265/415/622",
      "https://picsum.photos/id/311/415/622",
      "https://picsum.photos/id/316/415/276",
    ],
  },
];
const PhotoGalleryNew = () => {
  const [activeTab, setActiveTab] = useState();
  const [activeTabContent, setActiveTabContent] = useState();
  const [searchResults, setSearchResults] = useState({});
  const [departmentId, setDepartmentId] = useState();
  const [loading, setLoading] = useState(false);
  const [scheduleReqData, setScheduleReqData] = useState({
    DoctorID: "",
    PreferredDate: "",
    doctorData: "",
  });

  useEffect(() => {
    const getCaseStudies = (data) => {
      try {
        setLoading(true);
        const req = scAxiosAdmin
          .request(`/album/listalbum`, {
            method: "get",
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
            },
          })
          .then((data) => {
            if (data.status === 200) {
              setLoading(false);
              setSearchResults(data.data.data);
              setActiveTabContent(data.data.data[0]);
              setActiveTab(data.data.data[0].id);
            }
          })
          .catch((e) => {
            setLoading(false);
            console.log("your log output", e);
          });
      } catch (error) {}
    };
    getCaseStudies();
  }, []);

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
    if (tabId) {
      const tabContent = searchResults.find((tab) => tab.id === tabId);
      setActiveTabContent(tabContent);
    }
  };

  return (
    <div>
      <SEO
        title={
          "Photo Gallery | United Hospital Bangladesh | Best Hospital In Bangladesh"
        }
        description={"Photo Gallery of United Hospital Bangladesh Limited"}
        pathSlug="/gallery/photo-gallery"
        keywords="newsevents, Singlenewsevents"
      />
      <Helmet>
        <meta
          name="description"
          content="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
        />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "http://schema.org",
            "@type": "LocalBusiness",
            name: "United Hospital Limited",
            image:
              "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
            telephone: "10666",
            email: "info@uhlbd.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "plot 15, Road 71, Gulshan",
              addressLocality: "Dhaka",
              addressRegion: "Dhaka",
              addressCountry: "Bangladesh",
              postalCode: "1212",
            },
            openingHoursSpecification: {
              "@type": "OpeningHoursSpecification",
              opens:
                "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30",
            },
            url: "http://www.uhlbd.com/",
            aggregateRating: {
              "@type": "AggregateRating",
              ratingValue: "3.9",
              bestRating: "5",
              worstRating: "1",
              ratingCount: "756",
            },
            review: {
              "@type": "Review",
              author: {
                "@type": "Person",
                name: "abdul kahar",
              },
              datePublished: "2019-02-12",
              reviewRating: {
                "@type": "Rating",
                ratingValue: "3.9",
                bestRating: "5",
                worstRating: "1",
              },
              reviewBody:
                "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)",
            },
          })}
        </script>
        <meta
          name="Subject"
          content="Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
        />
        <meta name="Abstract" content="one-stop healthcare in Bangladesh" />
        <meta name="Googlebot" content="all" />
        <meta http-equiv="imagetoolbar" content="no" />
        <meta name="robots" content="index, follow" />
        <meta name="copyright" content="Copyright &copy; uhlbd.com" />
        <meta name="owner" content="United Hospital" />
        <meta name="author" content="dcastalia.com" />
        <meta name="Rating" content="General" />
        <meta name="distribution" content="Global" />
        <meta
          name="classification"
          content="Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
        />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta
          names="apple-mobile-web-app-status-bar-style"
          content="black-translucent"
        />
        <meta name="msvalidate.01" content="16C4E0B16E39354E550F64BD707F6A97" />
      </Helmet>
      <Route component={Header} />
      <div id="giveMargin" className="" style={{ backgroundColor: "#fef3e9" }}>
        <img src={banner_img} alt="banner-profile" className="w-100" />
        <section className="container">
          <div className="d-flex flex-column justify-content-between align-items-center pt-4">
            <div className="1">
              <h3
                className="text-left "
                style={{
                  color: "#0C807D",
                  fontSize: "28px",
                  fontWeight: "500",
                  display: "flex",
                  flexDirection: "column",
                  
                }}
              >
                Photo Gallery
                {/* <img
                  src={case_under}
                  style={{ width: "100%", maxWidth: "79px" }}
                  alt=""
                /> */}
              </h3>
            </div>
          </div>
        </section>
        {searchResults.length > 0 ? (
          <section className="termscondbody">
            <div className="px-3 py-0 photoContainer">
              {/* <h2 className="text-secondary">Photo Gallery</h2> */}
              <div
                className="row g-3 w-100 justify-content-center"
                style={{ margin: "0 auto" }}
              >
                <div className="col-md-12 flex-row">
                  <div className="col-md-12 flex-row d-flex flex-column align-items-center">
                    <ul
                      className="gallery-tab nav nav-pills px-0 container mb-5 d-flex flex-wrap flex-column flex-md-row justify-content-center justify-content-md-between"
                      id="pills-tab"
                      role="tablist"
                    >
                      {searchResults &&
                        searchResults.map((tab) => (
                          <li
                            className="nav-item"
                            key={tab.id}
                            role="presentation"
                            // style={{ width: "20%" }}
                          >
                            <button
                              className={`nav-link ${
                                activeTab === tab.id ? "active" : ""
                              }`}
                              onClick={() => handleTabClick(tab.id)}
                              role="tab"
                              style={{
                                background:
                                  activeTab === tab.id ? "#0C807D" : "",
                                width: "100%",
                              }}
                            >
                              {tab.album_name}
                            </button>
                          </li>
                        ))}
                    </ul>
                    <div className="tab-content w-100" id="pills-tabContent">
                      {searchResults
                        ? searchResults.map((tab) => (
                            <div
                              key={tab.id}
                              className={`tab-pane fade ${
                                activeTab === tab.id ? "show active" : ""
                              }`}
                              role="tabpanel"
                            >
                              <PhotoGalleryTabInner
                                activeTabContent={activeTabContent}
                              />
                            </div>
                          ))
                        : ""}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        ) : (
          ""
        )}
      </div>
      <Route component={Footer} />
    </div>
  );
};

export default PhotoGalleryNew;

// const getAlbums = (data) => {
//   return new Promise((resolve, reject) => {
//     const req = scAxiosAdmin.request("/album/listalbum", {
//       method: "get",
//       headers: {
//         Accept: "application/json",
//         Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
//       },
//       params: {
//         ...data,
//       },
//     });
//     req.then((res) => resolve(res.data)).catch((err) => reject(err));
//   });
// };

// class PhotoGalleryNew extends Component {
//   state = {
//     galleries: [],
//   };
//   refreshGallery = (event) => {
//     getAlbums()
//       .then((res) => {
//         if (res.status === true) {
//           var records = res.data;
//           this.setState({ galleries: records });
//         } else {
//           this.setState({ galleries: "" });
//         }
//       })
//       .catch((err) => {
//         console.log(err);
//       });
//   };

//   componentDidMount() {
//     this.refreshGallery();
//   }

//   render() {
//     const boardmembers = [
//       {
//         title:
//           "Workplace diversity refers to the variety of differences between people in an organization. That sounds simple, but diversity encompasses race, gender, ethnic group, age, personality, cognitive style, tenure, organizational function, education, background and more. Diversity not only involves how people perceive themselves, but how they perceive others. Those perceptions affect their interactions. For a wide assortment of employees to function effectively as an organization, human resource professionals need to deal effectively with issues such as communication, adaptability and change.",
//         dsc: "United Hospital employs a diverse workforce to attend to supply a great diversity of clinical and non-clinical and management solutions to address issues in service, sourcing, and allocation of resources. Employees from diverse backgrounds bring individual talents and experiences in suggesting ideas which are customized to fit to the demands of customers (patients). This enhances the dynamism of the organization to serve its varied patients with an international flare.",
//       },
//     ];
//     return (
//       <div>
//         <SEO
//           title={
//             "Photo Gallery | United Hospital Bangladesh | Best Hospital In Bangladesh"
//           }
//           description={"Photo Gallery of United Hospital Bangladesh Limited"}
//           pathSlug="/gallery/photo-gallery"
//           keywords="newsevents, Singlenewsevents"
//         />
//         <Helmet>
//           <meta
//             name="description"
//             content="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
//           />

//           <script type="application/ld+json">
//             {JSON.stringify({
//               "@context": "http://schema.org",
//               "@type": "LocalBusiness",
//               name: "United Hospital Limited",
//               image:
//                 "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
//               telephone: "10666",
//               email: "info@uhlbd.com",
//               address: {
//                 "@type": "PostalAddress",
//                 streetAddress: "plot 15, Road 71, Gulshan",
//                 addressLocality: "Dhaka",
//                 addressRegion: "Dhaka",
//                 addressCountry: "Bangladesh",
//                 postalCode: "1212",
//               },
//               openingHoursSpecification: {
//                 "@type": "OpeningHoursSpecification",
//                 opens:
//                   "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30",
//               },
//               url: "http://www.uhlbd.com/",
//               aggregateRating: {
//                 "@type": "AggregateRating",
//                 ratingValue: "3.9",
//                 bestRating: "5",
//                 worstRating: "1",
//                 ratingCount: "756",
//               },
//               review: {
//                 "@type": "Review",
//                 author: {
//                   "@type": "Person",
//                   name: "abdul kahar",
//                 },
//                 datePublished: "2019-02-12",
//                 reviewRating: {
//                   "@type": "Rating",
//                   ratingValue: "3.9",
//                   bestRating: "5",
//                   worstRating: "1",
//                 },
//                 reviewBody:
//                   "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)",
//               },
//             })}
//           </script>
//           <meta
//             name="Subject"
//             content="Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
//           />
//           <meta name="Abstract" content="one-stop healthcare in Bangladesh" />
//           <meta name="Googlebot" content="all" />
//           <meta http-equiv="imagetoolbar" content="no" />
//           <meta name="robots" content="index, follow" />
//           <meta name="copyright" content="Copyright &copy; uhlbd.com" />
//           <meta name="owner" content="United Hospital" />
//           <meta name="author" content="dcastalia.com" />
//           <meta name="Rating" content="General" />
//           <meta name="distribution" content="Global" />
//           <meta
//             name="classification"
//             content="Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
//           />
//           <meta name="apple-mobile-web-app-capable" content="yes" />
//           <meta
//             names="apple-mobile-web-app-status-bar-style"
//             content="black-translucent"
//           />
//           <meta
//             name="msvalidate.01"
//             content="16C4E0B16E39354E550F64BD707F6A97"
//           />
//         </Helmet>
//         <Route component={Header} />
//         <div
//           id="giveMargin"
//           className=""
//           style={{ backgroundColor: "#fef3e9" }}
//         >
//           <img src={banner_img} alt="banner-profile" className="w-100" />
//           <section className="termscondbody mt-5 pb-5">
//             <div className="container p-3">
//               <h2 className="text-secondary">Photo Gallery</h2>
//               <div className="row g-3 w-100 mx-auto">
//                 <div className="col-md-12 mt-5 bg-light flex-row">
//                   <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
//                     <li class="nav-item" role="presentation">
//                       <button
//                         class="nav-link active"
//                         id="pills-home-tab"
//                         data-bs-toggle="pill"
//                         data-bs-target="#pills-home"
//                         type="button"
//                         role="tab"
//                         aria-controls="pills-home"
//                         aria-selected="true"
//                       >
//                         Home
//                       </button>
//                     </li>
//                     <li class="nav-item" role="presentation">
//                       <button
//                         class="nav-link"
//                         id="pills-profile-tab"
//                         data-bs-toggle="pill"
//                         data-bs-target="#pills-profile"
//                         type="button"
//                         role="tab"
//                         aria-controls="pills-profile"
//                         aria-selected="false"
//                       >
//                         Profile
//                       </button>
//                     </li>
//                     <li class="nav-item" role="presentation">
//                       <button
//                         class="nav-link"
//                         id="pills-contact-tab"
//                         data-bs-toggle="pill"
//                         data-bs-target="#pills-contact"
//                         type="button"
//                         role="tab"
//                         aria-controls="pills-contact"
//                         aria-selected="false"
//                       >
//                         Contact
//                       </button>
//                     </li>
//                   </ul>
//                   <div class="tab-content" id="pills-tabContent">
//                     <div
//                       class="tab-pane fade show active"
//                       id="pills-home"
//                       role="tabpanel"
//                       aria-labelledby="pills-home-tab"
//                     >
//                      <PhotoGalleryTabInner></PhotoGalleryTabInner>
//                     </div>
//                     <div
//                       class="tab-pane fade"
//                       id="pills-profile"
//                       role="tabpanel"
//                       aria-labelledby="pills-profile-tab"
//                     >
//                       <PhotoGalleryTabInner></PhotoGalleryTabInner>
//                     </div>
//                     <div
//                       class="tab-pane fade"
//                       id="pills-contact"
//                       role="tabpanel"
//                       aria-labelledby="pills-contact-tab"
//                     >
//                       <PhotoGalleryTabInner></PhotoGalleryTabInner>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </section>
//         </div>
//         <Route component={Footer} />
//       </div>
//     );
//   }
// }
// export default PhotoGalleryNew;



// WEBPACK FOOTER //
// ./src/component/frontend/PhotoGalleryNew/PhotoGalleryNew.js